export async function playAudio(name) {
  try {
    const audio = new Audio(`/audio/${name}`);
    await audio?.play();
  } catch (err) {
    console.warn('Could not play audio file')
  }
}
